// src/utils/userId.ts
import uuid from 'react-uuid';

export function getOrCreateUserId(): string {
  const key = 'userId';
  let userId = localStorage.getItem(key);
  if (!userId) {
    userId = uuid();
    localStorage.setItem(key, userId);
  }
  return userId;
}
